module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "default-value": _vm.deadTime,
            "type": "date",
            "placeholder": "过期截止日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (_vm.deadTime),
            callback: function($$v) {
              _vm.deadTime = $$v
            },
            expression: "deadTime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.exportLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchExport()
            }
          }
        }, [_vm._v("\n            批量导出"), (_vm.exportList.length) ? _c('span', [_vm._v(" (" + _vm._s(_vm.exportList.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 || _vm.userInfo.type == 0) ? _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.importLoading
          },
          on: {
            "click": function($event) {
              return _vm.batchImport()
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "importProbation",
            "name": "file",
            "accept": ".xls,.xlsx"
          },
          on: {
            "change": function($event) {
              return _vm.importCompanyFile($event)
            }
          }
        })], 1) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("试用客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级试用客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("试用用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校试用用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院试用用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          ref: "companyTable",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "row-key": "id",
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "reserve-selection": true,
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "250",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "syuc",
            "label": "试用用户数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "purpleNumber"
              }, [_vm._v(_vm._s(scope.row.syuc ? scope.row.syuc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "正式产品总数",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "blue_num"
              }, [_vm._v(_vm._s(scope.row.ac ? scope.row.ac : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "即将过期产品数量",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "orange"
              }, [_vm._v(_vm._s(scope.row.dc ? scope.row.dc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "fixed": "right",
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc21527"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/probationCustom.vue
// module id = 1814
// module chunks = 9